// console.log("App 2") //*Princy
define(['integration/quoteandbind/SupportedLobModules', 'edge/quoteandbind/quickquote/app', 'edge/policyjob/app', 'edge/platform/navigation/module'
], (SupportedLobModules)=> {

    SupportedLobModules.push('edge.quoteandbind.quickquote.app');
    SupportedLobModules.push('edge.policyjob.app');
    SupportedLobModules.push('edge.platform.navigation');

    return angular.module('edge.quoteandbind.app', SupportedLobModules);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/app.js
 **/